// extracted by mini-css-extract-plugin
export default {"puzzleContentRoot":"PuzzleContent_puzzleContentRoot__EigpH","solved":"PuzzleContent_solved__juSzS","hints":"PuzzleContent_hints__eD3K5","newHint":"PuzzleContent_newHint__wcmq+"};